<!--
 * @Author: ZhaoG
 * @Date: 2025-05-14 11:37:51
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-06-05 17:48:30
 * @FilePath: \gcp-fe\src\app\procurementNotice\components\evaluate-list.vue
 * @Description: 评标/评审结果公示、中标结果公示   表格组件
-->
<template>
  <div class="wrapper">
    <div class="ccui-app-container">
      <!--评标结果-->
      <!--table表格区域Begin-->
      <div class="ccui-multifunctional-table-wrapper">
        <listBaseTable
          :tableName="tableName"
          :showCheckBox="false"
          :showOp="false"
          :data="tableData"
          :cellStyle="cellStyle"
          :pageNo.sync="pageNo"
          :pageSize.sync="pageSize"
          :pageTotal="pageTotal"
          :fixedTableThead="fixedTableThead"
          :unfixedTableThead="unfixedTableThead"
          border
          @handleList="handleList"
          ref="table"
          @select-all="handleCheckAllChange"
          @select="handleCheckChange"
          @selection-change="handleSelectionChange"
        >
          <!--列表中的插槽Begin-->
          <template slot="schemeCode" slot-scope="{ row }">
            <el-button
              class="column-btn-ellipsis"
              size="mini"
              type="text"
              @click="check(row)"
            >
              {{ row.schemeCode }}
            </el-button>
          </template>
          <!--列表中的插槽End-->
        </listBaseTable>
      </div>
      <!--table表格区域End-->
    </div>
  </div>
</template>

<script>
// import { mixinListCommon } from "@/mixins/mixin-common/mixin-list";
import { commonTableWidth } from "@/setting/setting";
import { qryEsNoticePageList } from "@/app/shop/api/shoppingSP";
import Cookies from "js-cookie";
import moment from "moment";
// import $t from "@/app/shop/utils/translateUtil";
// import { encBlackList, querySupJoinFlag } from "@/app/shop/api/shopping";
// import { addUrlPerFix } from "@/basa/utils";
import formOptions from "../js/formOptions";

export default {
  name: "noticeViewAllList",
  // mixins: [mixinListCommon],

  props: {
    active: {
      type: Number,
      default: 0
    },
    noticeTime: {
      type: Array,
      default: () => []
    },

    form: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      formOptions,
      tableName: this.tableList.viewMoreList, // 默认的tableName 工程中唯一
      isSelection: false,
      formData: {},
      formDataSearch: {},
      tableData: [],
      unfixedTableTheadAll: [],
      fixedTableThead: [],
      unfixedTableThead: [
        {
          label: "序号",
          type: "index",
          checked: true
        },
        {
          label: "采购编号",
          prop: "schemeCode",
          width: 200,
          checked: true,
          slot: "schemeCode"
        },
        // 公告名称
        {
          label: this.$t("page.content.title"),
          prop: "noticeTitle",
          width: 300,
          checked: true
        },
        {
          //采购方式
          label: this.$t("page.content.purchaseType"),
          prop: "purchaseTypeName",
          width: 200,
          checked: true
          // slot: "purchaseTypeName"
        },
        {
          //状态
          label: this.$t("page.content.status"),
          prop: "signUpStatusName",
          width: 150,
          checked: true
          // slot: "noticeStatusName"
        },

        {
          label: this.$t("page.content.publishTime"),
          prop: "noticeReleaseTime",
          width: commonTableWidth.dateTimeWidth,
          checked: true
        }
      ],
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      supInfo: this.$store.state.user.supInfo || {}
    };
  },

  methods: {
    // $t, // 移植代码存在国际化方案临时解决
    initData() {
      this.pageNo = 1;
      this.pageSize = 10;
      this.pageTotal = 0;
      this.formData = {};
      this.formDataSearch = {};
      this.tableName = this.tableList.viewMoreList;
    },
    handleList() {
      // 分页操作列表
      this.getNoticeList();
    },
    getNoticeList() {
      let param = {
        isShowLoading: true,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        noticeType: this.form.noticeType,
        mergePurchaseTypeList: this.form.mergePurchaseTypeList, //采购方式
        noticeTitle: this.form.noticeTitle, //公告名称
        dataSourceFlag: this.active == 4 ? 2 : null,
        keyWord: sessionStorage.getItem("searchName") || ""
      };
      //采购类型
      if (this.active == 0 || this.active == 4) {
        param.schemeClass = null;
      } else {
        param.schemeClass = this.active - 1;
      }
      if (this.form.noticeType == 3 || this.form.noticeType == 4) {
        param.singUpStatus = this.form.singUpStatus;
      } else {
        if (param.singUpStatus) {
          this.$delete(param, "singUpStatus");
        }
      }
      if (
        Cookies.get("language") !== undefined &&
        Cookies.get("language") !== "zh-cn"
      ) {
        param.overseasSupFlag = 1;
      }
      if (this.noticeTime && this.noticeTime.length !== 0) {
        this.formDataSearch.noticeTimeStart = this.noticeTime[0] + " 00:00:00";
        this.formDataSearch.noticeTimeEnd = this.noticeTime[1] + " 23:59:59";
      } else {
        this.formDataSearch.noticeTimeStart = null;
        this.formDataSearch.noticeTimeEnd = null;
      }
      Object.assign(param, this.formDataSearch);
      this.$delete(param, "noticeTime");
      qryEsNoticePageList(param).then(res => {
        if (res.data.code === "0") {
          this.tableData = res.data.data.rows.map(item => {
            item.noticeStartTime = item.noticeStartTime
              ? moment(item.noticeStartTime).format("YYYY-MM-DD HH:mm")
              : "";
            item.noticeTypeName = this.formOptions.typeOptions.filter(
              item => item.value == this.form.noticeType
            )[0].label;
            item.noticeType = this.form.noticeType;
            return item;
          });
          this.pageTotal = res.data.data.recordsTotal;
        }
      });
    },
    search(searchData) {
      this.pageNo = 1;
      this.formDataSearch = searchData;
      this.getNoticeList();
    },
    //查看
    check(row) {
      if (["107407", "118352", "119934"].includes(row.baseAppId)) {
        //租赁
        let url =
          this.$addUrlPerFix(process.env.VUE_APP_YZ_URL) +
          "/leaseMall/viewNoticeDetail?" +
          "schemeId=" +
          row.schemeId +
          "&schemeCode=" +
          row.schemeCode +
          "&schemeName=" +
          encodeURIComponent(row.schemeName) +
          "&noticeId=" +
          row.noticeId +
          "&opUnitName=" +
          row.opUnitName +
          "&opUnitId=" +
          row.opUnitId +
          "&purchaseType=" +
          "" +
          row.purchaseType +
          "&schemeStatus=" +
          row.schemeStatus +
          "&checkFlag=" +
          row.checkFlag +
          "&supCode=" +
          row.supCode +
          "&supName=" +
          row.supName;
        window.open(url, "_blank");
        return;
      } else if (["118353", "107412", "119952"].includes(row.baseAppId)) {
        //物流
        let url =
          this.$addUrlPerFix(process.env.VUE_APP_WLY_URL) +
          "/#/detail?" +
          "schemeId=" +
          row.schemeId +
          "&schemeCode=" +
          row.schemeCode +
          "&schemeName=" +
          encodeURIComponent(row.schemeName) +
          "&noticeId=" +
          row.noticeId +
          "&opUnitName=" +
          row.opUnitName +
          "&opUnitId=" +
          row.opUnitId +
          "&purchaseType=" +
          "" +
          row.purchaseType +
          "&schemeStatus=" +
          row.schemeStatus +
          "&checkFlag=" +
          row.checkFlag +
          "&supCode=" +
          row.supCode +
          "&supName=" +
          row.supName;
        window.open(url, "_blank");
        return;
      } else if (["107428", "118497", "119912"].includes(row.baseAppId)) {
        //云仓
        let url =
          this.$addUrlPerFix(process.env.VUE_APP_YC_URL) +
          `/leaseMall/viewNoticeDetail?schemeId=${row.schemeId}&noticeId=${row.noticeId}&schemeCode=${row.schemeCode}&schemeName=${row.schemeName}`;
        window.open(url, "_blank");
        return;
      } else if (["100065"].includes(row.baseAppId)) {
        let objSession = JSON.parse(sessionStorage.getItem("usedSupInfo"));
        let obj = {
          schemeId: row.schemeId,
          noticeId: row.noticeId,
          opUnitName: row.opUnitName,
          opUnitId: row.opUnitId,
          purchaseType: row.purchaseType,
          schemeStatus: row.schemeStatus,
          supplierFlag: 1,
          noticeTypeName: row.noticeTypeName,
          type: row.noticeType,
          supCode: objSession.supCode,
          supName: objSession.supName
        };

        this.$router.push({
          path: "/viewNoticeSimpleDetailFB",
          query: obj
        });
        // }
      } else {
        let url = this.$router.resolve({
          path: "/viewNoticeSimpleDetail",
          query: {
            schemeId: row.schemeId,
            schemeCode: row.schemeCode,
            schemeName: row.schemeName,
            noticeId: row.noticeId,
            opUnitName: row.opUnitName,
            opUnitId: row.opUnitId,
            purchaseType: row.purchaseType,
            schemeStatus: row.schemeStatus,
            checkFlag: row.checkFlag,
            supCode: row.supCode,
            supName: row.supName,
            type: row.noticeType
          }
        });
        window.location.href = url.href;
      }
      // window.location.href = url.href;
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 判断高亮行
      return { color: "#0089EF", cursor: "pointer" };
    },
    handleCheckAllChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleCheckChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleSelectionChange(arr) {
      this.isSelection = arr.length !== 0;
    }
  },

  watch: {
    // tab标签
    active: {
      handler(val) {
        if (val == 4) {
          this.dataSourceFlag = 2;
        } else {
          this.dataSourceFlag = null;
        }
        this.pageNo = 1;
        this.getNoticeList();
      }
    },
    "form.noticeType": {
      handler(val) {
        this.pageNo = 1;
        this.getNoticeList();
      },
      deep: true,
      immediate: true
    },

    // 采购方式
    "form.mergePurchaseTypeList": {
      handler(val) {
        this.pageNo = 1;
        this.getNoticeList();
      }
    },
    // 状态
    "form.singUpStatus": {
      handler(val) {
        this.pageNo = 1;
        this.getNoticeList();
      }
    },
    // 公告名称
    "form.noticeTitle": {
      handler(val) {
        this.pageNo = 1;
        this.getNoticeList();
      }
    },

    noticeTime: {
      handler(val) {
        this.pageNo = 1;
        this.getNoticeList();
      }
    }
  }
};
</script>

<style scoped lang="scss">
/deep/.el-searchs {
  display: none;

  .icon-ccui-downdown {
    display: none;
  }
}

/deep/.ccui-search-wrapper {
  display: none;
}

/deep/.ccui-advanced-search-wrapper {
  .el-search .el-searchs-bottom .el-form-item .el-form-item__label {
    min-width: 0 !important;
    width: auto !important;
  }
}

/deep/.el-form-item__content {
  margin-right: 20px;
}

/deep/.el-col-8 {
  width: 28%;
}

/deep/.el-col-24 {
  width: 170px;
}

/deep/.icon-ccui-downdown {
  display: none;
}
</style>
